import { useNavigate } from "react-router-dom";

//material-ui
import { Grid, Card, CardHeader, Button, CardContent, OutlinedInput, InputAdornment } from "@mui/material";
import ViewIcon from "@mui/icons-material/Visibility";

//hooks
import { useAppSelector } from "../../hooks/reduxHooks";

//components
import DeviceSettings from "./DeviceSettings";

//helpers
import { timestampFormatDateTime } from "../../helpers/timestampFormat";

interface DeviceGridProps {
	Devices: Device[] | null;
	JobSummaries: JobSummary[] | null;
	refetch: () => void;
}

const DeviceGrid = ({ Devices, JobSummaries, refetch }: DeviceGridProps) => {
	const FromDevices = useAppSelector((state) => state.device);
	const navigate = useNavigate();

	return (
		<Grid container spacing={3} alignItems="stretch" direction="row">
			{Devices?.map((Device) => {
				let DeviceID = Device.DeviceID;
				let JobSummary = JobSummaries?.find((j) => j.DeviceID === DeviceID);
				let FromDevice = FromDevices[DeviceID];
				if (!Device || !JobSummary) return null;
				return (
					<Grid item xs={12} sm={6} md={4} key={DeviceID}>
						<Card variant="outlined" style={{ height: "100%" }}>
							<CardHeader
								action={
									<Button aria-label="view" variant="contained" startIcon={<ViewIcon />} onClick={() => navigate("/counter/" + DeviceID)}>
										View
									</Button>
								}
								title={Device.Title}
							/>
							<CardContent>
								<Grid container spacing={3}>
									<Grid item xs={12}>
										<OutlinedInput
											sx={{ fontSize: "larger" }}
											fullWidth
											value={FromDevice?.Quantity || "-"}
											endAdornment={<InputAdornment position="start">Count</InputAdornment>}
											aria-describedby="count"
											inputProps={{
												readOnly: true,
												disabled: true,
											}}
										/>
									</Grid>
									<Grid item xs={12}>
										{JobSummary.JobID && !JobSummary.Posted ? (
											<Grid container spacing={1}>
												<Grid item xs={6}>
													<b>JobId:</b> {JobSummary.JobID}
												</Grid>
												<Grid item xs={6}>
													<b>Target</b> {Number(JobSummary?.TargetQuantity) - Number(JobSummary?.CompletedQuantity)}
												</Grid>
												<Grid item xs={12}>
													{JobSummary.Botanical}
												</Grid>
												<Grid item xs={6}>
													<b>Started</b>
													<br />
													{timestampFormatDateTime(Number(JobSummary.CreateDate))}
												</Grid>
												<Grid item xs={6}>
													<b>Last Count</b>
													<br />
													{timestampFormatDateTime(Number(FromDevice?.DeviceTime), 1000)}
												</Grid>
												<Grid item xs={6}>
													<b>SW</b> {JobSummary.StartWeek}
												</Grid>
												<Grid item xs={6}>
													<b>RW</b> {JobSummary.ReadyWeek}
												</Grid>
												<Grid item xs={12}>
													<b>Size</b> {JobSummary.Size}
												</Grid>
											</Grid>
										) : (
											<Grid container spacing={1}>
												<Grid item xs={6}>
													<b>No Current Job</b>
												</Grid>
											</Grid>
										)}
									</Grid>
									<Grid item xs={12}>
										<DeviceSettings Device={Device} refetch={refetch} />
									</Grid>
								</Grid>
							</CardContent>
						</Card>
					</Grid>
				);
			})}
		</Grid>
	);
};

export default DeviceGrid;
